import { useGoalById } from 'features/goals';
import React from 'react';
import { useParams } from 'react-router';

import { GoalDetailHeader } from './components/goal-detail-header';
import { ProgressSection } from './components/progress-section';
import { SubItemsSection } from './components/sub-items-section';
import { SummaryRoadmap } from './summary-roadmap';

export const Summary: React.FC = () => {
  const { id } = useParams();
  const goal = useGoalById(id);

  if (!goal) {
    return null;
  }

  const showRoadmap = goal.showRoadmap ?? true;

  return (
    <>
      <GoalDetailHeader />
      <ProgressSection />
      {showRoadmap && <SummaryRoadmap />}
      <SubItemsSection grow hasLink />
    </>
  );
};
